import { connect } from 'react-redux';
import IdValidation from 'account/components/id_verification/id_validation';

const mapStateToProps = ({ creativeRegistration }) => {
  const {
    idValidated, idValidationRejectionNote, idPhotoApproved, selfieApproved,
    idVerificationStatus
  } = creativeRegistration;

  return {
    idValidated,
    idPhotoApproved,
    selfieApproved,
    idVerificationStatus,
    rejectionNote: idValidationRejectionNote
  };
}

export default connect(mapStateToProps)(IdValidation);



// WEBPACK FOOTER //
// ./account/containers/id_verification/id_validation.js